import React from "react";

const IsAuthorizationContext = React.createContext({
  isAuthorization: "",
  setIsAuthorization: () => {},
});

export default IsAuthorizationContext;
